import { render, staticRenderFns } from "./selectGroup.vue?vue&type=template&id=8545b440&scoped=true&"
import script from "./selectGroup.vue?vue&type=script&lang=js&"
export * from "./selectGroup.vue?vue&type=script&lang=js&"
import style0 from "./selectGroup.vue?vue&type=style&index=0&id=8545b440&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8545b440",
  null
  
)

export default component.exports